import React from 'react';

const SvgApps = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    width={props.width || 42}
    height={props.height || 43}
    viewBox="0 0 42 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2853_5692)">
      <path
        d="M22.7746 24.25H19.2254C18.6883 24.25 18.25 23.8117 18.25 23.2746V19.7254C18.25 19.1883 18.6883 18.75 19.2254 18.75H22.7746C23.3117 18.75 23.75 19.1883 23.75 19.7254V23.2746C23.75 23.8117 23.3117 24.25 22.7746 24.25ZM31.0246 24.25H27.4754C26.9383 24.25 26.5 23.8117 26.5 23.2746V19.7254C26.5 19.1883 26.9383 18.75 27.4754 18.75H31.0246C31.5617 18.75 32 19.1883 32 19.7254V23.2746C32 23.8117 31.5617 24.25 31.0246 24.25ZM14.5246 24.25H10.9754C10.4383 24.25 10 23.8117 10 23.2746V19.7254C10 19.1883 10.4383 18.75 10.9754 18.75H14.5246C15.0617 18.75 15.5 19.1883 15.5 19.7254V23.2746C15.5 23.8117 15.0617 24.25 14.5246 24.25Z"
        fill="currentColor"
      />
      <path
        d="M22.7746 24.25H19.2254C18.6883 24.25 18.25 23.8117 18.25 23.2746V19.7254C18.25 19.1883 18.6883 18.75 19.2254 18.75H22.7746C23.3117 18.75 23.75 19.1883 23.75 19.7254V23.2746C23.75 23.8117 23.3117 24.25 22.7746 24.25ZM31.0246 24.25H27.4754C26.9383 24.25 26.5 23.8117 26.5 23.2746V19.7254C26.5 19.1883 26.9383 18.75 27.4754 18.75H31.0246C31.5617 18.75 32 19.1883 32 19.7254V23.2746C32 23.8117 31.5617 24.25 31.0246 24.25ZM14.5246 24.25H10.9754C10.4383 24.25 10 23.8117 10 23.2746V19.7254C10 19.1883 10.4383 18.75 10.9754 18.75H14.5246C15.0617 18.75 15.5 19.1883 15.5 19.7254V23.2746C15.5 23.8117 15.0617 24.25 14.5246 24.25Z"
        fill="currentColor"
      />
      <path
        d="M22.7746 16H19.2254C18.6883 16 18.25 15.5617 18.25 15.0246V11.4754C18.25 10.9383 18.6883 10.5 19.2254 10.5H22.7746C23.3117 10.5 23.75 10.9383 23.75 11.4754V15.0246C23.75 15.5617 23.3117 16 22.7746 16ZM31.0246 16H27.4754C26.9383 16 26.5 15.5617 26.5 15.0246V11.4754C26.5 10.9383 26.9383 10.5 27.4754 10.5H31.0246C31.5617 10.5 32 10.9383 32 11.4754V15.0246C32 15.5617 31.5617 16 31.0246 16ZM14.5246 16H10.9754C10.4383 16 10 15.5617 10 15.0246V11.4754C10 10.9383 10.4383 10.5 10.9754 10.5H14.5246C15.0617 10.5 15.5 10.9383 15.5 11.4754V15.0246C15.5 15.5617 15.0617 16 14.5246 16Z"
        fill="currentColor"
      />
      <path
        d="M22.7746 32.5H19.2254C18.6883 32.5 18.25 32.0617 18.25 31.5246V27.9754C18.25 27.4383 18.6883 27 19.2254 27H22.7746C23.3117 27 23.75 27.4383 23.75 27.9754V31.5246C23.75 32.0617 23.3117 32.5 22.7746 32.5ZM31.0246 32.5H27.4754C26.9383 32.5 26.5 32.0617 26.5 31.5246V27.9754C26.5 27.4383 26.9383 27 27.4754 27H31.0246C31.5617 27 32 27.4383 32 27.9754V31.5246C32 32.0617 31.5617 32.5 31.0246 32.5ZM14.5246 32.5H10.9754C10.4383 32.5 10 32.0617 10 31.5246V27.9754C10 27.4383 10.4383 27 10.9754 27H14.5246C15.0617 27 15.5 27.4383 15.5 27.9754V31.5246C15.5 32.0617 15.0617 32.5 14.5246 32.5Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2853_5692">
        <rect width={22} height={22} fill="currentColor" transform="translate(10 10.5)" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgApps;
